import React, { useState } from 'react';
import {getLogger} from '@ignitesales/logger-es';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import FormContainer from './Forms/FormContainer';
import FormInput from './Forms/FormInput';
import NeuroMessage from './NeuroMessage';
import useNeuroState, {
  triggerIgniteAction,
  sendResultsViaEmail,
  useDispatch
} from '../state';

const logger = getLogger({ module: 'ShareViaEmailForm' });

const ShareViaEmailForm = ({
  className,
  initialValue = null,
  onSubmit,
  shouldCopyEmployee,
  skipSending
}) => {
  const dispatch = useDispatch();
  const {
    user: { assignment: { employee } = {} } = {}
  } = useNeuroState(); //TODO: change to useUser hook

  const formId = 'shareViaEmail';
  const classes = classnames(className, 'socialForm', 'shareViaEmailForm');
  const [emailAddress, setEmailAddress] = useState(initialValue);

  const onChange = ({ value }) => {
    setEmailAddress(value);
  };

  const onFormSubmit = () => {
    const sendEmailParams = {
      email: emailAddress,
      fromEmail: employee && employee?.email ? employee.email : null,
      copyMe: employee && shouldCopyEmployee,
    };
    logger.debug('ShareViaEmailForm submitted', sendEmailParams);
    dispatch(triggerIgniteAction({ actionName: 'shareViaEmailClicked' }));
    if(!skipSending)
      dispatch(sendResultsViaEmail(sendEmailParams));
    onSubmit && onSubmit(emailAddress);
  };

  return (
    <section className={classes}>
      <NeuroMessage id="shareViaEmail.formBody" tagName="p" />
      <FormContainer onSubmit={onFormSubmit} formId={formId} renderDefaultSubmit={true}>
        <FormInput
          formId={formId}
          initialValue={initialValue}
          name="emailAddress"
          required={true}
          isEmail={true}
          onChange={onChange}
        />
      </FormContainer>
    </section>
  );
};
ShareViaEmailForm.propTypes = {
  className: PropTypes.string,
  initialValue: PropTypes.string,
  onSubmit: PropTypes.func,
  shouldCopyEmployee: PropTypes.bool,
  skipSending: PropTypes.bool
};

export default ShareViaEmailForm;
